/**
 * Bullet physics motion type
 */
export var MotionType;
(function (MotionType) {
    /**
     * Dynamic motion type Rigid bodies are affected by forces and can be moved by the user
     */
    MotionType[MotionType["Dynamic"] = 0] = "Dynamic";
    /**
     * Static motion type Rigid bodies are not affected by forces and cannot be moved by the user
     */
    MotionType[MotionType["Static"] = 1] = "Static";
    /**
     * Kinematic motion type Rigid bodies are not affected by forces but can be moved by the user
     */
    MotionType[MotionType["Kinematic"] = 2] = "Kinematic";
})(MotionType || (MotionType = {}));
